import React, { Component } from 'react';
import { connect } from 'react-redux';
import ImageManager from 'MyAccount/AssetManager/ImageManager/ImageManager';
import { getCurrentFolderImages } from 'MyAccount/AssetManager/ImageManager/selectors';
import { closeSnackbar } from 'MyAccount/ViewDesigns/redux/modules/images';

@connect(
  state => ({
    selectedFolder: state.images.Images.selectedFolder,
    photos: getCurrentFolderImages(state, {
      resourceType: 'Images',
      currentFolder: state.images.Images.selectedFolder,
    }),
    uploadFiles: state.images.Images.uploadFiles,
    snackbarData: state.images.Images.snackbarData,
  }),
  { closeSnackbar }
)
export default class ImageManagerWrap extends Component {
  componentDidMount() {
    const { selectedFolder, photos, uploadFiles } = this.props;
    this.props.getImageManagerState({
      currentFolder: selectedFolder,
      photos: photos,
      uploadFiles: uploadFiles,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { selectedFolder, photos, uploadFiles } = this.props;
    if (selectedFolder !== nextProps.selectedFolder || photos !== nextProps.photos ||
      uploadFiles !== nextProps.uploadFiles) {
      this.props.getImageManagerState({
        currentFolder: nextProps.selectedFolder,
        photos: nextProps.photos,
        uploadFiles: nextProps.uploadFiles,
      });
    }
  }

  render() {
    const { selectedFolder, uploadImagesDirectToEditor, snackbarData, closeSnackbar, ...otherProps } = this.props;
    return (
      <ImageManager
        currentFolder={selectedFolder}
        integrated
        type="images"
        uploadImagesDirectToEditor={uploadImagesDirectToEditor}
        snackbarData={snackbarData}
        closeSnackbar={closeSnackbar}
        { ...otherProps }
      />
    );
  }
}
